/** RTP of a level on fixed rates: read-only in the table, set in the pack's Fixed rates block. */
export function FixedRtpValue({ rtp }: { rtp: number | null }) {
  return (
    <span className="inline-flex items-center" title="Fixed rate: this level pays this RTP at its own win rate.">
      <span className="font-mono">{rtp != null ? `${rtp}%` : '—'}</span>
      <span className="ml-2 rounded-full bg-sky-100 px-1.5 py-0.5 text-[10px] font-semibold text-sky-800">
        fixed
      </span>
    </span>
  );
}
